/* TAIBI · Urgenza reale del selettore kit.
   Usa gli stessi dati già presenti su [data-taibi-pdp]: ora limite, ora da cui
   mostrare il countdown e fuso del negozio. Nessun timer promozionale fittizio. */
(() => {
  'use strict';

  const SELECTOR = '[data-taibi-livelli-urgenza]';

  function parseOffset(raw) {
    const match = String(raw || '').match(/^([+-])(\d{2})(\d{2})$/);
    if (!match) return 0;
    const minutes = Number(match[2]) * 60 + Number(match[3]);
    return match[1] === '-' ? -minutes : minutes;
  }

  function two(n) {
    return String(n).padStart(2, '0');
  }

  function update(el) {
    const pdp = el.closest('[data-taibi-pdp]');
    const prefix = el.querySelector('[data-taibi-urgenza-prefix]');
    const accent = el.querySelector('[data-taibi-urgenza-accent]');
    const suffix = el.querySelector('[data-taibi-urgenza-suffix]');
    if (!pdp || !prefix || !accent || !suffix) return;

    const cutoffHour = Number(pdp.dataset.taibiTaglio || 12);
    const countFromHour = Number(pdp.dataset.taibiContoDa || 8);
    const offsetMinutes = parseOffset(pdp.dataset.taibiFuso);

    const storeNow = new Date(Date.now() + offsetMinutes * 60000);
    const day = storeNow.getUTCDay(); // 0 dom, 6 sab nel fuso del negozio
    const minutesNow = storeNow.getUTCHours() * 60 + storeNow.getUTCMinutes();
    const cutoffMinutes = cutoffHour * 60;
    const countFromMinutes = countFromHour * 60;
    const weekday = day >= 1 && day <= 5;

    function setLine(p, a, s = '') {
      prefix.textContent = p;
      accent.textContent = a;
      suffix.textContent = s;
      suffix.hidden = !s;
    }

    if (weekday && minutesNow < cutoffMinutes) {
      el.dataset.state = 'today';
      if (minutesNow >= countFromMinutes) {
        const remaining = cutoffMinutes - minutesNow;
        const h = Math.floor(remaining / 60);
        const m = remaining % 60;
        const left = h > 0 ? `${h}h ${two(m)}m` : `${m} min`;
        setLine('Ordina entro', left, '· partenza oggi');
      } else {
        setLine('Ordina entro', `le ${two(cutoffHour)}:00`, '· partenza oggi');
      }
      return;
    }

    el.dataset.state = 'later';
    if (day === 5 || day === 6 || day === 0) {
      setLine('Prossima partenza', 'lunedì mattina');
    } else {
      setLine('Prossima partenza', 'domani mattina');
    }
  }

  function updateAll() {
    document.querySelectorAll(SELECTOR).forEach(update);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateAll, { once: true });
  } else {
    updateAll();
  }

  document.addEventListener('shopify:section:load', updateAll);
  document.addEventListener('shopify:block:select', updateAll);
  // Dawn replaces the selector after the server response for the selected kit.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, updateAll);
  }
  document.addEventListener('change', (event) => {
    if (event.target && event.target.closest('variant-selects')) {
      window.setTimeout(updateAll, 0);
    }
  });

  window.setInterval(updateAll, 30000);
})();
